<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      clock: null,
      refresh_interval: 1000,
      last_time: Date.now(),
    }
  },

  mounted: function () {
    this.clock = $('#reservation-clock').FlipClock({
      countdown: true,
      autoStart: false
    })

    this.$watch('reservation_transaction.attributes.transaction_seconds_remaining', function (val) {
      this.setClockTime()
    })

    this.setClockTime()

    this.startHandler()
  },

  destroyed: function () {
    this.clock.stop()

    this.stopHandler()
  },

  computed: {
    ...mapState({
      current: state =>
        state.reservation.current,
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      is_terminating: state =>
        state.reservation.current.is_terminating
    })
  },

  methods: {
    ...mapActions([
      'getCurrentReservation',
      'setIsExpiring',
      'setIsVisible'
    ]),

    /*
     * Start the clock monitoring interval.
     */
    startHandler: function () {
      this.handler = setInterval(() => {
        this.stayAwake()

        this.checkTime()
      }, this.refresh_interval)
    },

    /*
     * Stop the clock monitoring interval.
     */
    stopHandler: function () {
      clearInterval(this.handler)
    },

    setClockTime: function () {
      this.clock.setTime(
        this.reservation_transaction.attributes.transaction_seconds_remaining
      )

      if (this.reservation_transaction.attributes.transaction_seconds_remaining < 86400) {
        this.clock.loadClockFace('HourlyCounter', {
          showSeconds: true
        })
      } else {
        this.clock.loadClockFace('DailyCounter', {
          showSeconds: false
        })
      }
    },

    checkTime: function () {
      // The reservation has <= 8 hours left (i.e. it is expiring soon)
      if(! this.current.is_expiring && this.clock.getTime().time <=
          this.current.expired_seconds_remaining) {
        let payload = { is_expiring: true }
        this.setIsExpiring(payload)
      }

      // The clock has stopped running
      if(! this.clock.running) {
        this.stopHandler()

        let payload = { is_visible: false }
        this.setIsVisible(payload)

        // Redirect if the clock reached zero
        if (! this.is_terminating && window.location.href.indexOf('/connect') > -1) {
          window.location.reload(true)
        }
      }
    },

    stayAwake: function () {
      let current_time = Date.now()

      if (current_time > (this.last_time + this.current.refresh_interval)) {
        this.getCurrentReservation()
      }

      this.last_time = current_time
    }
  }
}
</script>

<template>
  <div id="reservation-clock" class="clock"></div>
</template>
